import React from 'react';
import { useHistory } from 'react-router-dom';

// Shared feature-page header — translates the prototype's editorial pattern
// (crumbs, Instrument Serif italic h1 with a terracotta <em>, lead copy).
// Used as the landing header for every redesigned feature page.
interface FeaturePageHeaderProps {
  crumbs?: { label: string; path?: string }[];
  title: React.ReactNode;        // e.g. <>Chore <em>ledger.</em></>
  lead?: React.ReactNode;
  rightContent?: React.ReactNode;
}

const FeaturePageHeader: React.FC<FeaturePageHeaderProps> = ({ crumbs, title, lead, rightContent }) => {
  const history = useHistory();
  const trail = crumbs && crumbs.length > 0 ? crumbs : [{ label: 'Home', path: '/app/home' }];
  return (
    <div className="fhv2-fpage-header">
      <div>
        <div className="fhv2-crumbs">
          {trail.map((c, i) => (
            <React.Fragment key={i}>
              {c.path ? (
                <button onClick={() => history.push(c.path!)} className="fhv2-unset">{c.label}</button>
              ) : (
                <span>{c.label}</span>
              )}
              {i < trail.length - 1 ? <span className="s">/</span> : null}
            </React.Fragment>
          ))}
        </div>
        <h1>{title}</h1>
        {lead ? <p>{lead}</p> : null}
      </div>
      {rightContent ? <div>{rightContent}</div> : null}
    </div>
  );
};

export default FeaturePageHeader;
